import router from "@/router/router.ts";
import { loadTld } from "@/utils/storage";
import i18n from "@/i18n.ts";
import { RouteLocation } from "vue-router";
import { useVisitStore } from "@/store/visit.ts";

export const updateUrl = async (
  route: RouteLocation,
  args: Record<string, any>,
  newPath: string | null = null,
  hash: string | null = null,
): Promise<void> => {
  const params = new URLSearchParams(route.query as Record<string, string>);

  Object.keys(args).map((k) => {
    const v = args[k];

    if (v === null) {
      params.delete(k);
    } else {
      params.set(k, v);
    }
  });
  let url = newPath || route.path;

  if (params.toString() !== "") {
    url += `?${params.toString()}`;
  }

  if (hash !== null) {
    url += hash;
  }

  if (url !== route.fullPath) {
    await router.push(url);
  }
};

export const getApiHost = (): string => import.meta.env.VITE_API_HOST as string;

export const getTld = (): string => loadTld() || window.location.origin.split(".").pop();

export const getAffiliateUrl = (): string => {
  const visitStore = useVisitStore();
  return visitStore.getVisit?.country.toLowerCase() === "de" ? "https://www.vxcash.net/" : "https://affiliates.ersties.com/signup-request";
};

export const getBlogUrl = (): string => {
  return i18n.global.locale === "de" ? "/lecker_blog" : "/blog";
};

export const isInternalLink = (url: string): boolean => {
  return url.startsWith("/");
};
